import {formatPrice,checkAusbildung} from "./logic";
const Saetze = require('./saetze.js');
import {kinder_vorhanden,get_anz_kinder} from "./kinder.js";

class Einkommen {
    // TODO Stipendium bis 400 €
    /**
     *
     * @param einnahmen
     * @param monate
     * @param ausbildung
     */
    constructor( einnahmen,
                monate = 12,
                ausbildung = null)
    {
        this.einnahmen = einnahmen;
        this.monate = monate;
        this.ausbildung = ausbildung;
        this.WERBUNGSKOSTEN = Saetze.WERBUNGSKOSTEN;
        this.SOZIAL_PAUSCHALE_UMG = Saetze.SOZIAL_PAUSCHALE_UMG;
        this.FREIBETRAG_EINKOMMEN_STUDENTSELBST = Saetze.FREIBETRAG_EINKOMMEN_STUDENTSELBST;
        this.FREIBETRAG_WAISE_STUDI = Saetze.FREIBETRAG_WAISE_STUDI;
        this.FREIBETRAG_WAISE_SCHUELERMIT = Saetze.FREIBETRAG_WAISE_SCHUELERMIT;
        this.FREIBETRAG_WAISE_SCHUELEROHNE = Saetze.FREIBETRAG_WAISE_SCHUELEROHNE;
    }

    get null() {
        return this.berechneNull();
    }
    /**
     * 0 zurückgeben
     * @returns {string}
     */
    berechneNull() {
        return formatPrice(0);
    }

    get praktikum() {
        return this.berechnePraktikum();
    }
    /**
     * berechnen vom Praktikum
     * @returns {number}
     */
    berechnePraktikum(){
        let abzuege = 0.00;
        if(this.einnahmen > 0){
            abzuege = this.einnahmen * this.SOZIAL_PAUSCHALE_UMG / 12;
        }
        if (abzuege > 0){
            return parseFloat(abzuege.toFixed(2));
        }
        return 0;
    }

    get nichtselbst() {
        return this.berechneAbzuegeNichtSelbststaendigeArbeit();
    }
    /**
     * nichtselbständige Arbeit berechnen
     * @returns {number}
     */
    berechneAbzuegeNichtSelbststaendigeArbeit() {
        let abzuege = 0.00;
        if (this.einnahmen && this.einnahmen > 0) {
            abzuege = ((((this.einnahmen - (this.WERBUNGSKOSTEN / 12 * this.monate)) * this.SOZIAL_PAUSCHALE_UMG) ) / this.monate) - this.FREIBETRAG_EINKOMMEN_STUDENTSELBST;
            //kinder = $this->getKinderFormatiert();
            /*if (kinder != null) {
                for (kind of kinder) {
                    $einkommenSubFreibetrag = $kind['brutto'] - FREIBETRAG_KIND;
                    if ($einkommenSubFreibetrag > 0)
                        $abzuege += $einkommenSubFreibetrag;
                }
            }*/
            //console.log('ns-abzüge: '+abzuege)
            if (abzuege > 0){
                return parseFloat(abzuege.toFixed(2));
            }
        }
        return 0;
    }

    get selbst() {
        return this.berechneAbzuegeSelbststaendigeArbeit();
    }
    /**
     * selbständige Arbeit berechnen
     * !soz-pauschale, wie nicht selbstständige (nur bei Eltern 37%)
     * @returns {number}
     */
    berechneAbzuegeSelbststaendigeArbeit() {
        let abzuege = 0.00;
        if (this.einnahmen && this.einnahmen > 0) {
            abzuege = ((this.einnahmen * this.SOZIAL_PAUSCHALE_UMG) / this.monate) - this.FREIBETRAG_EINKOMMEN_STUDENTSELBST;
            if (abzuege > 0){
                return parseFloat(abzuege.toFixed(2));
            }
        }
        return 0;
    }

    get waise() {
        return this.berechneWaisenrente();
    }
    /**
     * Abzüge wegen Waisenrente berechnen
     * @returns {number}
     */
    berechneWaisenrente() {
        let abzuege = 0.00;
        this.einnahmen /= this.monate
        //console.log(ausbildung)
        switch (this.ausbildung){
            case 'student': case 'meister':
                abzuege = this.einnahmen - this.FREIBETRAG_WAISE_STUDI
                break;
            case 'schuelermit':
                abzuege = this.einnahmen - this.FREIBETRAG_WAISE_SCHUELERMIT
                break;
            case 'schuelerohne':
                abzuege = this.einnahmen - this.FREIBETRAG_WAISE_SCHUELEROHNE
                break;
            default:
                return this.einnahmen
        }

        if (abzuege > 0){
            return parseFloat(abzuege.toFixed(2));
        }
        return 0;
    }
}

/**
 * Einkommen berechnen
 * @param $this
 * @param aus
 */
function einkommenBerechnen($this, aus = false){
    checkboxDisable($this, 5)
    if(aus) {
        const nu = new Einkommen(0,12);
        $this.el$('results.einkommen').value = nu.null
    }else{
        calculateEinkommen($this)
    }
}

/**
 * prüfen, ob Button nicht auswählbar sind
 * @param $this
 * @param $a
 */
function checkboxDisable($this, $a){
    let i;
    if (!$this.el$('Einkommen.art').value) { // Einkommen.art nicht aktiv
        //console.log('Einkommen.art leer')
    }else{ // Einkommen.art aktiv
        //console.log('EK aktiv: '+$this.el$('Einkommen.art').value)
        if($this.el$('Einkommen.art').value.includes(5)){
            for (i = 0; i < $a; i++) {
                //console.log('disable '+i)
                $this.el$('Einkommen.art').disable(i)
                $this.el$('Einkommen.art').uncheck(i)
            }
            // einkommen Abzug auf 0
            $this.el$('results.einkommen').value = formatPrice(0)
        }else if($this.el$('Einkommen.art').value.includes(4)){
            for (i = 0; i < $a-1; i++) {
                //console.log('disable 4 '+i)
                $this.el$('Einkommen.art').disable(i)
                $this.el$('Einkommen.art').uncheck(i)
            }
            // einkommen Abzug auf 0
            $this.el$('results.einkommen').value = formatPrice(0)
        }else{
            for (i = 0; i < $a; i++) {
                //console.log('enable '+i)
                $this.el$('Einkommen.art').enable(i)
            }
        }
    }
}

/**
 * Abzüge für das Einkommen berechnen
 * @param $this
 */
function calculateEinkommen($this){

    //console.log('EK-Arten: '+$this.el$('Einkommen.art').value)
    // alle ausgewählten Einkommen in ein Array schreiben
    let values = $this.el$('Einkommen.art').value
    // Einkommensarten berechnen
    let abzuege = 0.00;
    let anzahlKinder = 0;
    let freibetrag_einkommen_kinder = Saetze.FREIBETRAG_KIND
    for (let wert of values){
        switch(wert) {
            case 0: // Praktikum
                const pr = new Einkommen($this.el$('Einkommen.praktikum').value,12);
                let prak = pr.praktikum
                abzuege += prak
                //console.log('Praktikum: '+prak)
                break;
            case 1: // Nicht selbständige Arbeit
                const na = new Einkommen($this.el$('Einkommen.nichtselbst').value,12);
                let ns = na.nichtselbst
                abzuege += ns
                //console.log('Nicht selbständige Arbeit: '+ns)
                break;
            case 2: // selbständige Arbeit
                const as = new Einkommen($this.el$('Einkommen.selbst').value,12);
                let sa = as.selbst
                abzuege += sa
                //console.log('selbständige Arbeit: '+sa)
                break;
            case 3: // Waisenrente
                const wa = new Einkommen($this.el$('Einkommen.waise').value,12, checkAusbildung($this));
                let wr = wa.waise
                abzuege += wr
                //console.log('Waisenrente: '+wr)
                break;
            default:
                break;
        }
    }
    /**
     * Kinderfreibetrag abziehen
     */
    if(kinder_vorhanden($this)){
        anzahlKinder = get_anz_kinder($this)
        abzuege -= anzahlKinder*freibetrag_einkommen_kinder
        if(abzuege<0){
            abzuege = 0
        }
    }
    //console.log('Einkommen: '+abzuege)
    $this.el$('results.einkommen').value = formatPrice(abzuege)
}

/**
 * Funktionen exportieren
 */
export {einkommenBerechnen};
